import React from "react";
import { Card, Image, Rating, Grid, Divider, Label } from "semantic-ui-react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import img1 from "../../../../assets/images/insp1.png"
import img2 from "../../../../assets/images/insp2.png"
import { useTranslation } from "react-i18next";
import "./SearchCard.css"


const SearchCard = ({ data , mobile, computer, tablet}) => {
  const { t } = useTranslation();

  return  data && data.length !== 0 ? data.map((item, index) => {
      return <Grid.Column mobile={mobile} tablet={tablet} computer={computer} key={index} className="p-0">
        <Card className="boxshadow-none rounded-15 w-100 m-1-b">

          <Card.Content>
            <Swiper
              modules={[Navigation]}
              navigation
              loop={true}
              pagination={{ clickable: true }}
              onSlideChange={() => console.log("changed")}
              onSwiper={(swiper) => console.log(swiper)}
              slidesPerView={1}
              spaceBetween={50}


            >
              <SwiperSlide>
                <div className="w-100 h-300px m-1-b ">
                  <Image src={img1} size="large" className="w-100 h-100 rounded-20" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="w-100 h-300px m-1-b ">
                  <Image src={img2} size="large" className="w-100 h-100 rounded-20" />
                </div>
              </SwiperSlide>
            </Swiper>
            <Rating size="large" className="bg-white rounded-10 p-05 position-absolute top-2 left-2 z-index-2" icon='heart' defaultRating={0} maxRating={1} />
            <Card.Header className="d-flex flex-column m-05">
              <span className="font-bold d-flex flex-row align-items-center ">  {item.location}</span>
            </Card.Header>
            <Card.Description className="m-05">
              <span className="d-flex flex-row align-items-center justify-content-between flex-wrap">

                <Label size="large" basic className="p-0 border-none d-flex flex-row align-items-center ">
                  {t("property:PricePerNight")} :
                  <span className=" m-05-r m-05-l"> {item.pricePerNight} </span>
                </Label>
                <span className="d-flex flex-row align-items-center">
                  <Rating className="font-tiny" defaultRating={3} maxRating={5} disabled/>
                  <span className="m-3px font-bold"> ۳.۵</span>
                  ( ۳ {t("property:Reviews")} )
                </span>
              </span>
            </Card.Description>
            <Card.Meta className="text-overflow-ell font-thin">
              {
                item.type === "immidiate" ? <Label size="tiny" color="orange" className="m-05-r m-05-l">{t("property:ImmidiateRelocation")}</Label> :
                  item.type === "new" ? <Label size="tiny" color="blue" className="m-05-r m-05-l">{t("property:New")}</Label>
                    : null
              }
              <span className="m-05-r m-05-l">{item.description}</span>
            </Card.Meta>
          </Card.Content>
        </Card>
      </Grid.Column>
    }) : null
}
export default SearchCard